import Vue from 'vue'
import $ from 'jquery';
export default {
  //null转成空字符串
  convertNull :function (e) {
    if(this.isNull(e)){
      return "";
    }else {
      return e;
    }
  },
  //增加心跳，上传大文件时防止token超期
  addHeartBeat: function () {
    var timer = window.setInterval(function () {
      Vue.prototype.getRequest("/heartbeat", {})
    }, 1000 * 60)
    $(window).bind('beforeunload', function () {
      if (timer) {
        clearInterval(timer);
      }
    });
  },
  //是否为NULL
  isNull: function (e) {
    var isNull = false;
    if (e == null) {
      return true;
    }
  },
  //是否为空
  isEmpty: function (e) {
    var isNull = false;
    if (e == "") {
      return true;
    }
  },

  //触发键盘enter键的方法
  loadEnterFun:function (fun) {
    document.onkeydown = function (e) {
      var key = e.keyCode;
      if (key == 13) {
        fun();
      }
    }
  }
}
